import { gql } from 'graphql-tag';
import type { TypedDocumentNode, DocumentNode } from '@apollo/client';

export const GET_STUDENTS_BASE = <T>(
  {
    student = gql`
      fragment Student on StudentType {
        id
      }
    `,
  }: { student?: DocumentNode } = { student: undefined }
): TypedDocumentNode<T> => gql`
  query getStudents {
    viewer {
      id
      site {
        id
        students {
          ...Student
        }
      }
    }
  }
  ${student}
`;
